import { logout } from '../../actions/AuthenticationActionCreators';

async function doLogout(nextState) {
  console.info('Logging user out');
  const context = nextState.routes[0].getContext();
  await context.executeAction(logout, {});

  return {};
}

export default doLogout;



// WEBPACK FOOTER //
// ./src/utils/route/logout.js